import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import CardMedia from '@comeon/ui/src/cards/base/card-media.tsx';
import Card from '@comeon/ui/src/cards/base/card.tsx';
import LazyLoadImage from '~/components/utilities/lazyload-image.js';
import { hasDepositLoginSelector } from '~/components/casino-shared/ducks/selectors';
import useGameLauncher from '~/components/casino-shared/explore/utilities/use-game-launcher.js';
import useToggleGameInfo from '~/components/casino-shared/explore/utilities/use-toggle-game-info.js';
import { WinnerCardContainer, WinnerInfoContainer, CardImageContainer } from './winner-card-styles.js';
import { GAME_MODE } from '~/components/casino-shared/constants';
import useTranslations from '~/components/translation/use-translations';

const TEXT_KEYS = ['MOBILE_EXPLORE_WINNERITEM_ANONYMOUS', 'MOBILE_EXPLORE_WINNERITEM_WON'];

const CONTAINER_WIDTH = '104px';

const WinnerCard = ({
	game,
	game: {
		code,
		imageView: { srcSmall, srcSet, formats },
		name,
		gameId,
		gameSiteId
	},
	winnerDetail,
	listName,
	index,
	trackGameClick
}) => {
	const { translations: t } = useTranslations(TEXT_KEYS);

	const hasDepositLogin = useSelector(hasDepositLoginSelector);
	const { gameLauncher } = useGameLauncher();
	const { toggleGameInfo } = useToggleGameInfo();

	const imageComponent = useMemo(
		() => (
			<LazyLoadImage
				alt={name}
				src={srcSmall}
				srcSet={srcSet}
				sizes={CONTAINER_WIDTH}
				pictureElementData={formats}
			/>
		),
		[name, srcSmall, srcSet, formats]
	);

	const playGame = event => {
		if (trackGameClick) trackGameClick({ game, mode: GAME_MODE.REAL, position: index });
		if (hasDepositLogin) {
			// Some franchises have two options to login
			// We know them if they not regularSiteType, check => selectIsRegularSiteType
			// DepositLogin and regular login
			// So we are opening game-info and let user can choose which one
			event.stopPropagation();
			toggleGameInfo(code, listName, index);
		} else {
			gameLauncher({
				event,
				mode: GAME_MODE.REAL,
				game,
				listName,
				listGameIndex: index
			});
		}
	};

	return (
		<WinnerCardContainer onClick={playGame} role="presentation">
			<Card
				data-at="winner-feed-game-card"
				data-game-name={name}
				data-gamecode={code}
				data-gamesiteid={gameSiteId}
				data-gameid={gameId}
				alignItemsCenter
				cardLayout="horizontal"
			>
				<CardImageContainer data-at="winner-feed-game-card-image" containerWidth={CONTAINER_WIDTH}>
					<CardMedia src={srcSmall} srcSet={srcSet} lazyload imageComponent={imageComponent} />
				</CardImageContainer>
				<WinnerInfoContainer>
					<p data-at="winner-feed-game-card-title" className="game-card__title--small">
						{name}
					</p>
					<h3 data-at="winner-feed-game-card-detail" className="game-card__title--detail">
						<span>
							{winnerDetail?.playerName
								? winnerDetail?.playerName
								: t.MOBILE_EXPLORE_WINNERITEM_ANONYMOUS}
						</span>
						<span>{t.MOBILE_EXPLORE_WINNERITEM_WON}</span>
						<span>{winnerDetail?.winAmount}</span>
					</h3>
				</WinnerInfoContainer>
			</Card>
		</WinnerCardContainer>
	);
};

export default WinnerCard;
